// removed by extract-text-webpack-plugin
module.exports = {"TrdResultL":"TrdResultLess__-loca-__WJ_Ul","Highlight":"TrdResultLess__-loca-__3sJe7","IndexL":"TrdResultLess__-loca-__EPm4J","RegNameL":"TrdResultLess__-loca-__2Y2gw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdAdminFocus/TrdResultLess/TrdResultLess.css
// module id = 205
// module chunks = 0